import { render, staticRenderFns } from "./Window.vue?vue&type=template&id=20f38e80&scoped=true&lang=pug"
import script from "./Window.vue?vue&type=script&lang=ts"
export * from "./Window.vue?vue&type=script&lang=ts"
import style0 from "./Window.vue?vue&type=style&index=0&id=20f38e80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f38e80",
  null
  
)

/* custom blocks */
import block0 from "./Window.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports